import React,{useEffect} from 'react';
import { Panel } from 'primereact/panel';
import { GraficoReembolso } from './GraficoReembolso';

import { ProgressSpinner } from 'primereact/progressspinner';
 
import { Ultimos } from './Ultimos';
import { IGraficoKPI } from '../../../interfaces/IGraficoKPI';
import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import HistorialTablaReembolsos from '../../ReembolsoExpress/components/HistorialTablaReembolsos';

import { SUCCESS_GET_KPIS } from '../Utilities/constants';
import { ProgressSpinnerDemo } from '../../shared/components/progressSpinnerDemo/ProgressSpinnerDemo';
import { getKpis2 } from '../Services/home.service';
import Spinner from '../../shared/components/Spinner';
import ScanOCR_banner from "../../../images/datascan-banner.jpg";
import { HavePermissionOCR } from '../../cargarPresentacion/services/presentaciones.services';

interface IProps {
    
}


export const DashBoard = (props: IProps) => {      
    const [kpisData,setKpisData] = useState<any>()
    const [spinnerKpis,setSpinnerKpis] = useState<boolean>(true)
    const [presentacionOCR,setpresentacionOCR] = useState<boolean>(true)
    
    useEffect(() => {
      (async () => {
        const  permisoOCR = await HavePermissionOCR();
        setpresentacionOCR(permisoOCR.data.presentacionOCR);
        const {data,status} = await getKpis2()
        if(status === 200){
            setKpisData(data.respuesta)
            setSpinnerKpis(false)
        }else{
            setSpinnerKpis(false)
        }
      }
      )()
    }, [])

  return (
    <div className="layout-main">
         {
               !presentacionOCR && (
                <div className="panel-wrapper m-0">
                                {/* <Panel header="DataScan"> */}
                                    <div className="row">
                                        <div className="datascan-banner">
                                            <a 
                                                href="https://wa.me/5491134978082" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="datascan-banner-link"
                                            >
                                                <img 
                                                    src={ScanOCR_banner}
                                                    alt="Módulo DataScan - Lectura automática de comprobantes"
                                                    className="datascan-banner-image"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                {/* </Panel> */}
                            </div>
               )
             } 
 
                 <div className="panel-wrapper">
                     <Panel header="Transacciones">
                         <div className="row">
                            
                         {spinnerKpis 
                         ? <ProgressSpinnerDemo/>
                         :<>
                            <div className="col-6">
                                 <Ultimos titulo="Últimos 30 Días"
                                    Data={(kpisData && kpisData.presentaciones30D) ? kpisData.presentaciones30D : undefined}
                                    tipo="Dia" CantidadTRX={kpisData.cantidadTRX30D}
                                    VolumenConsumido={kpisData.volumenConsumido30D}
                                    VolumenConsumidoPromedioTRX={kpisData.volumenConsumidoPromedioTRX30D} />
                            </div>
                            <div className="col-6">
                                <Ultimos titulo="Últimos 12 Meses"
                                    Data={(kpisData && kpisData.presentaciones12M) ? kpisData.presentaciones12M : undefined}
                                    tipo="Mes" CantidadTRX={kpisData.cantidadTRX12M}
                                    VolumenConsumido={kpisData.volumenConsumido12M}
                                    VolumenConsumidoPromedioTRX={kpisData.volumenConsumidoPromedioTRX12M} />
                            </div>
                         </>
                         }
 
                             
                        </div>
                    </Panel>
                </div>
                <div className="panel-wrapper">
                    <Panel header="Resumen de Pagos">
                        <div style={{ padding: '1em', lineHeight: '1.5' }}>
                            <GraficoReembolso redirect={true} cursor="pointer" />
                        </div>
                    </Panel>
                </div>
                <div className="panel-wrapper">
                    <Panel header="Detalle de Pagos" className="panel-historial-reembolso">
                        <HistorialTablaReembolsos />
                    </Panel>
                </div>
            </div>
  )
}

export default DashBoard